import React, { ComponentType, PureComponent } from 'react';
import { AppTextContext } from 'services/AppTextContext';

const withTextContext = <P extends object>(Component: ComponentType<P>) => {
  class WithContext extends PureComponent<P> {
    render() {
      return <AppTextContext.Consumer>{value => <Component {...this.props} {...value} />}</AppTextContext.Consumer>;
    }
  }

  return WithContext;
};

export default withTextContext;
